import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { categoriesArrayPropTypes, userPropTypes } from 'helpers/propTypes';
import { logout } from 'redux/actions/user.actions';
import { openLoginModal, openRegisterModal, openSearchModal } from 'redux/actions/modal.actions';
import { cartSizeSelector } from 'redux/selectors/cart.selector';

import Navbar from 'components/main/Header/Navbar';
import TopNav from 'components/main/Header/TopNav';
import NavbarTextil from 'components/main/Header/Navbar/NavbarTextil';
import TopNavTextil from 'components/main/Header/TopNav/TopNavTextil';
import NavbarNeo from 'components/main/Header/Navbar/NavbarNeo';
import TopNavNeo from 'components/main/Header/TopNav/TopNavNeo';

const HeaderContainer = (props) => {
  const {
    categories, cartSize, logoutAction, openLoginModalAction,
    openRegisterModalAction, openSearchModalAction, user,onlyUsers,
    client,subCategories,
  } = props;
  const [isMenuActive, setIsMenuActive] = useState(false);

  switch(client?.design) {
    case 3:
      return (
        <header className="header trans-300">
          <TopNavTextil
              logout={logoutAction}
              openLoginModal={openLoginModalAction}
              openRegisterModal={openRegisterModalAction}
              user={user}
              client={client}
            />
          <NavbarTextil
              cartSize={cartSize}
              categories={categories}
              closeMenu={() => setIsMenuActive(false)}
              isMenuActive={isMenuActive}
              isUserLoggedIn={!!user}
              openMenu={() => setIsMenuActive(true)}
              openSearchModal={openSearchModalAction}
              logout={logoutAction}
              openLoginModal={openLoginModalAction}
              openRegisterModal={openRegisterModalAction}
              user={user}
              show={onlyUsers == false || (onlyUsers == true && !!user)}
              client={client}
              subCategories={subCategories}
            />
        </header>
      )
      case 4:
       return (
         <header className="header header-neo trans-300">
           <TopNavNeo
             logout={logoutAction}
             openLoginModal={openLoginModalAction}
             openRegisterModal={openRegisterModalAction}
             user={user}
             client={client}
           />
           <NavbarNeo
             cartSize={cartSize}
             categories={categories}
             closeMenu={() => setIsMenuActive(false)}
             isMenuActive={isMenuActive}
             isUserLoggedIn={!!user}
             openMenu={() => setIsMenuActive(true)}
             openSearchModal={openSearchModalAction}
             logout={logoutAction}
             openLoginModal={openLoginModalAction}
             openRegisterModal={openRegisterModalAction}
             user={user}
             show={onlyUsers == false || (onlyUsers == true && !!user)}
             client={client}
             subCategories={subCategories}
           />
         </header>
       );
      default:
        return (
          <header className="header trans-300">
            {client && (!client.design || client.design ===2) ? <TopNav
              logout={logoutAction}
              openLoginModal={openLoginModalAction}
              openRegisterModal={openRegisterModalAction}
              user={user}
              client={client}
            />:<></> }
            <Navbar
              cartSize={cartSize}
              categories={categories}
              closeMenu={() => setIsMenuActive(false)}
              isMenuActive={isMenuActive}
              isUserLoggedIn={!!user}
              openMenu={() => setIsMenuActive(true)}
              openSearchModal={openSearchModalAction}
              logout={logoutAction}
              openLoginModal={openLoginModalAction}
              openRegisterModal={openRegisterModalAction}
              user={user}
              show={onlyUsers == false || (onlyUsers == true && !!user)}
              client={client}
              subCategories={subCategories}
            />
          </header>
        );
  }
};

const mapStateToProps = (state) => ({
  cartSize: cartSizeSelector(state),
  categories: state.category.items,
  user: state.user.data,
  onlyUsers:state.app.onlyUsers,
  client: state.app.client,
  subCategories: state.subCategory.items,
});

const mapDispatchToProps = (dispatch) => ({
  logoutAction: bindActionCreators(logout, dispatch),
  openLoginModalAction: bindActionCreators(openLoginModal, dispatch),
  openRegisterModalAction: bindActionCreators(openRegisterModal, dispatch),
  openSearchModalAction: bindActionCreators(openSearchModal, dispatch),
});

HeaderContainer.defaultProps = {
  user: null,
};

HeaderContainer.propTypes = {
  cartSize: PropTypes.number.isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  logoutAction: PropTypes.func.isRequired,
  openLoginModalAction: PropTypes.func.isRequired,
  openRegisterModalAction: PropTypes.func.isRequired,
  openSearchModalAction: PropTypes.func.isRequired,
  user: userPropTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);
